/* eslint-disable max-len */
import { memo } from 'react';

interface IArrowIcon {
  fill?: string;
  className?: string;
  classNamePatch?: string | undefined;
  width?: string;
  height?: string
}
function ArrowIcon({
  fill,
  className,
  classNamePatch,
  width,
  height,
}: IArrowIcon) {
  return (
    <svg
      width={width || '17'}
      height={height || '28'}
      viewBox="0 0 17 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.40937 14.2473L5.16188 13.9998L5.40937 13.7524L15.7477 3.41406L13.4142 1.08061L0.494974 13.9998L13.4142 26.9191L15.7477 24.5856L5.40937 14.2473Z"
        fill={fill || 'white'}
        stroke="white"
        strokeWidth="0.7"
        className={classNamePatch}
      />
    </svg>
  );
}

export default memo(ArrowIcon);
